<template>
  <a-modal
    :class="'jee-outer-modal'"
    :confirmLoading="confirmLoading"
    :visible="visible"
    :width="800"
    @cancel="handleCancel"
    @ok="handleSubmit"
    cancelText="关闭"
    style="top:20px;"
    title="调换企业"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="所属企业">
          <j-dict-select-tag
            :getPopupContainer="getParentModal"
            dictCode="`iwt-wf`.wf_consumer_corp,corp_name,id"
            placeholder="请选择所属企业"
            v-decorator="[ 'corpId', validatorRules.corpId]"
          />
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
  import { putAction } from '@/api/manage'

  export default {
    name: "ExchangeCorpModal",
    data () {
      return {
        visible: false,
        confirmLoading: false,
        validatorRules: {
          corpId: {
            rules: [{ required: true, message: '所属企业不能为空!' }],
          },
        },

        model: {},
        url: {
          edit: "/custom/user/edit",
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        form: this.$form.createForm(this)
      }
    },
    methods: {
      show (record) {
        this.form.resetFields();
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(record)) ;
        this.$nextTick(() => {
          this.form.setFieldsValue({ corpId: record.corpId });
        });
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
      },
      handleSubmit () {
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            this.confirmLoading = true;
            let formData = Object.assign(this.model, values);
            putAction(this.url.edit, {
              id: formData.id,
              corpId: formData.corpId,
              groupId: '',
            }).then((res) => {
              if (res.success) {
                this.$message.success(res.message);
                this.$emit('ok');
              } else {
                this.$message.warning(res.message)
              }
            }).finally(() => {
              this.confirmLoading = false;
              this.close();
            });
          }
        })
      },
      handleCancel () {
        this.close()
      },
      getParentModal () {
        return document.querySelector('.jee-outer-modal')
      }
    }
  }
</script>